// core and third party
import React from 'react';
import { ThemeProvider as MaterialUIProvider } from '@material-ui/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

// project
import SEO from '../Seo';
import TopBar from './Topbar/';
import MultiDestination from "./MultiDestination";
import HeaderTabs from './HeaderTabs';
import NewTopBar from "./NewTopBar";
import NewHeaderTabs from './NewHeaderTabs';
import Footer from './Footer';
import Socket from './Socket';
import MaterialUITheme from './Themes/materialui';
import ClientTheme from './Themes/client';
import Button from "../Button";
import Dialog from "../Dialog";
import RequiredPopup from '../requiredPopup';


import { store } from '../../store/configureStore';
import { getCartLength } from '../../utils/SettingsRetriever';
import IntlMessage from '../../LocaleEngine';

import Drawer from '../Drawer';
import Cart from '../../containers/Cart';

import history from '../../history';
import PushHistory from '../../utils/PushHistory';

// styles
import './index.scss';
import './styles/responsive.scss';

class LayoutTopbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: this.getCurrentStateFromStore(),
      showCartDrawer: false,
      cartLength: getCartLength(),
    }
  }

  onTrigger = () => {
    const blacklistedPaths = [
      '/shopping-cart/review',
      '/checkout/register',
      '/checkout/payment',
      '/checkout/customer-requirements',
      '/checkout/review',
      '/checkout/confirmed',
      '/checkout/completed/v2',
      '/checkout/error',
      '/logout',
      '/checkout/resetpassword'
    ];
      
    if (blacklistedPaths.indexOf(history.location.pathname) >= 0) {
        PushHistory('/shopping-cart/review');
    } else {
      this.setState({...this.state, showCartDrawer: true}, () => this.forceUpdate());
    }
  }

  getCurrentStateFromStore = () => {
    return {
      cart: store.getState().cart.cart.response
    }
  }

  updateStateFromStore = () => {
    const currentStoreState = this.getCurrentStateFromStore();
    const currentState = this.state.cart;

    if (currentState.cart !== currentStoreState.cart) {
      this.setState({...this.state, cart: currentStoreState}, () => {
        this.cartState();
      });
    }
  }

  componentDidMount() {
    this.cartState();
    this.unsubscribeStore = store.subscribe(this.updateStateFromStore);
  }

  componentWillUnmount() {
    this.unsubscribeStore();
  }

  cartState = () => {
    let state = this.state;
    const storedCart = state.cart.cart;

    let cartBadge = 0;
    let cartTotal = 0;

    if(storedCart){
        if(storedCart.items){
            storedCart.items.forEach(group => {
                group.items.forEach(item => {
                    let qty = 1;
                    let price = item.Price;
                    if(item.Quantity){
                        qty = item.Quantity;
                    }
                    if(item.UnitaryPrice){
                        price = item.UnitaryPrice;
                    }
                    cartTotal += parseFloat(price) * qty;
                    cartBadge += qty;
                });
            });
            storedCart.fees.forEach(fee => {
                cartTotal += parseFloat(fee.Amount) * 1;
            });
        }
    }

    state.cart.badge = cartBadge;
    state.cart.total = cartTotal;

    this.setState(state);
  }

  onCollapse = () => {
    this.setState({...this.state, showCartDrawer: false}, () => this.forceUpdate());
  }

  getTopBar = () => {
    let system = this.props.system;
    if (system){
      if(system.head && system.head.template){
        if (system.head.template === 2){
          return (
            <React.Fragment>
              <NewTopBar cartLength={this.state.cartLength} onTrigger={() => this.onTrigger()} />
              <NewHeaderTabs onCollapse={() => this.onCollapse()} showCartDrawer={this.state.showCartDrawer}  />
            </React.Fragment>
          )
        }
      }

      return (
        <React.Fragment>
          <TopBar
            configuration={this.props.system}
            cart={this.state.cart}
            cartLength={this.state.cartLength}
            onTrigger={() => this.onTrigger()} 
          />
          <Drawer 
            disablePortal={true} 
            onEscapeKeyDown={() => this.closeSideCart()} 
            onBackdropClick={() => this.onCollapse()} 
            variant={'temporary'} 
            anchor={'right'} 
            open={this.state.showCartDrawer} 
            className="summaryCartDrawer"
          >
            <Cart isDrawer={true}/>
          </Drawer>
          <MultiDestination />
          {
            system.head && system.head.hide_navbar 
            ? null 
            : 
            <HeaderTabs
              cart={this.state.cart}
              configuration={this.props.system}
              onTrigger={() => this.onTrigger()}
              onCollapse={() => this.onCollapse()} 
              showCartDrawer={this.state.showCartDrawer}  
            />
          }
        </React.Fragment>
      )
    }

    return null;
  }

  render() {
    return (
      this.getTopBar()
    )
  }
}

class HelpButton extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      dialog: false,
      button: null
    }

  }
  componentDidMount(){
    if (this.props.system && this.props.system.head && this.props.system.head.global_help && this.props.system.head.global_help.enabled){
      this.setState({ button: this.props.system.head.global_help })
    }
  }
  
  render(){
    const { state } = this;
    const{ dialog, button } = state;

    if (!button) return null;

    return (
      <div className="globalHelp">
        <Button className={"globalHelpModalTrigger " + button.style + " " + button.position} onClick={()=>this.setState({ dialog: true })}>
          {button.badge}
        </Button>
        <Dialog
            container={() => document.getElementsByClassName('globalHelp')[0]}
            open={dialog}
            className="helpDialog"
            closeFn={()=>this.setState({ dialog: false })}
            footerContent={
                <div className="footer">
                    <Button onClick={()=>this.setState({ dialog: false})} className="secondary">
                        <IntlMessage id="profile.itinerary.modal.close" />
                    </Button>
                </div>
            }
        >
            <div className="body">
                <div dangerouslySetInnerHTML={{__html: button.message}} />
            </div>
        </Dialog>
      </div>
    )
  }
}

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      system: this.props.system
    }
  }

  render() {
    document.addEventListener("updatedSystemSettings", (e) => {
      this.setState({system: e.detail});
    });
    return (
      <MaterialUIProvider theme={MaterialUITheme}>
        <CssBaseline />
        <ClientTheme system={this.state.system} className="main-application">
          <SEO title="Loading..." keywords={[`spotlio`, `booking`]} system={this.state.system} config={this.props.config} />
          <RequiredPopup />

          <LayoutTopbar system={this.state.system} />

          <HelpButton system={this.state.system} />

          <Container maxWidth="lg" className="viewWrapper" component="section">
            {this.props.children}
          </Container>

          <Footer />
          <Socket />

        </ClientTheme>
      </MaterialUIProvider>
    );
  }
}
